import { type FC, type ReactNode } from 'react';

// MUI
import TableHead from '@mui/material/TableHead';

interface StyledTableHeadProsp {
  children: ReactNode;
}

const StyledTableHead: FC<StyledTableHeadProsp> = ({ children }) => {
  return (
    <TableHead
      sx={(theme) => ({
        position: 'sticky',
        top: 0,
        bgcolor: theme.palette.background.paper,
      })}
    >
      {children}
    </TableHead>
  );
};

export default StyledTableHead;
